<template>
  <div class="grid-view">
    <div class="main-content entry-account-title">
      <div class="section operations">
        <div class="filters">
          <span v-if="!locked">
            <el-button type="primary" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
            <el-button type="primary" @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
          </span>
          <span v-else>
            <el-button type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
            <el-button type="danger" :disabled="!cellSelected" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
            <el-button type="primary" @click="refreshHandler">{{ $t('common.btn.refresh') }}</el-button>
          </span>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="min-height: 500px"
        />
      </div>
      <entry-account-dialog
        :visible.sync="entryAccountDialog.visible"
        :account-set="accountSet"
        :sub-account-item="entryAccountDialog.subAccountItem"
        :entry-rule="entryAccountDialog.entryRule"
        @close="dialogCloseHandler"
      />
    </div>
  </div>
</template>

<script>
import FinanceUtil from '@/utils/FinanceUtil'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import EntryAccountDialog from '@/views/cargo/v0/FinanceManage/FinanceInterface/EntryAccountDialog'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import { getLoading } from '@/utils/utilBaseElement'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as accountingEntryRuleApi from '@/api/financeManage/accountingEntryRule'
import * as accountingDocumentsRuleApi from '@/api/financeManage/accountingDocumentsRule'
import * as entryAccountTitleApi from '@/api/financeManage/entryAccountTitle'

export default {
  name: 'TitleMapping',
  components: { EntryAccountDialog },
  props: {
    accountSet: { type: Object, default: null }
  },
  data() {
    return {
      cellSelected: false, // 是否选中行
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor
        },
        onRowDoubleClicked: this.rowDoubleClickHandler,
        onRowClicked: (event) => { this.cellSelected = true; this.selectedItem = event.data }
      },
      rowData: [],
      locked: true,
      accountingDocumentRules: [],
      accountingDocumentsRuleOptions: [],
      entryTypeDataProvider: [],
      entryAccountDialog: {
        subAccountItem: null,
        entryRule: null,
        visible: false
      },
      nameDialog: {
        visible: false
      },
      selectedItem: {} // 表格选中项
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_VoucherGroupingType'),
          field: 'businessDataType',
          width: 130,
          valueFormatter: params => {
            return FinanceUtil.businessDataTypeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DataType'),
          field: 'entryType',
          width: 130,
          valueFormatter: params => {
            return FinanceUtil.entryTypeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitleName'),
          field: 'name',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FinancialCode'),
          field: 'code',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Level1AccountTitle'),
          field: 'level1',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Level2AccountTitle'),
          field: 'level2',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Level3AccountTitle'),
          field: 'level3',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Level4AccountTitle'),
          field: 'level4',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Level5AccountTitle'),
          field: 'level5',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Level6AccountTitle'),
          field: 'level6',
          width: 130
        }
      ]
    },
    accountSetUuid() {
      return this.accountSet.uuid
    }
  },
  watch: {
    locked(val) {
      this.gridOptions.columnApi.setColumnVisible('entrySeries', !val)
      this.gridOptions.columnApi.setColumnVisible('accountingCode', !val)
    },
    accountSetUuid() {
      this.loadaccountingDocumentRules()
      this.loadRules()
    }
  },
  async created() {
    // 加载列表
    this.loadList()
  },
  methods: {
    async loadList(rowData) {
      const loading = getLoading()
      const rowDataTemp = rowData || await entryAccountTitleApi.query({ accountSetUuid: this.accountSet.uuid }).then(resp => resp.data.list)
      for (const row of rowDataTemp) {
        if (row.subAccountItem) {
          for (const subItem of row.subAccountItem) {
            row['level' + subItem.grade] = subItem.name
          }
        }
      }
      this.rowData = rowDataTemp
      loading.close()
      this.gridOptions.api.clearFocusedCell()
      this.cellSelected = false
      this.selectedItem = {}
    },
    async loadaccountingDocumentRules() {
      const accountingDocumentRules = this.accountSet.accountingDocumentsRule // await accountingDocumentsRuleApi.query({ accountSetUuid: this.accountSet.uuid }).then(resp => resp.data.list)
      const arr = []
      for (const rule of accountingDocumentRules) {
        const el = {}
        el.uuid = rule.uuid
        el.name = this.bizTypeDDLLabelFun(rule)
        arr.push(el)
      }
      this.accountingDocumentRules = accountingDocumentRules
      this.accountingDocumentsRuleOptions = arr
    },
    loadRules() {
      const loading = getLoading()
      const params = {}
      params.accountSetUuid = this.accountSet.uuid
      accountingEntryRuleApi.query(params).then(resp => {
        this.rowData = resp.data.list
        this.gridOptions.api.refreshCells({ force: true })
      }).catch(() => {
        this.rowData = []
        this.gridOptions.api.refreshCells({ force: true })
      }).finally(() => loading.close())
    },
    addHandler() {
      this.entryAccountDialog.visible = true
    },
    editHandler() {
      if (this.rowData && this.rowData.length > 0) {
        this.locked = false
      }
    },
    saveHandler() {
      const saveList = []
      for (const rule of this.rowData) {
        if (['add', 'edit'].includes(rule.waitDealStatus)) {
          saveList.push(rule)
        }
      }
      if (saveList.length) {
        // 校验
        for (const rule of saveList) {
          if (!rule.accountingDocumentRuleUuid) {
            this.$message.info(this.$t('CargoMsg.Cargo_PSDTOVG'))
            return
          } else if (Number(rule.entryType) === -1) {
            this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectDataType'))
            return
          } else if (this.getDimensionCount(rule) !== Number(rule.entrySeries) - 1) {
            this.$message.info(this.$t('CargoMsg.Cargo_NOATGCAAIODMBETTGMO'))
            return
          }
        }
        // 保存
        const loading = getLoading('app-main-content')
        accountingEntryRuleApi.save(saveList).then(resp => {
          this.saveSuccess(resp)
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        }).finally(() => loading.close())
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataModifiedNoNeedToSave'))
      }
      this.locked = true
    },
    getDimensionCount(rule) {
      let count = 0
      for (let i = 1; i <= 6; i++) {
        if (rule['groupDime' + i]) {
          count++
        }
      }
      return count
    },
    cancelHandler() {
      this.locked = true
      this.loadRules()
    },
    refreshHandler() {
      this.loadList()
    },
    async removeHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const currentRow = cell ? this.selectedItem : null
      if (!currentRow) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_STDTATM'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        canCloseModule: true
      })
      const loading = getLoading()
      entryAccountTitleApi.remove({ uuid: currentRow.uuid }).then(resp => {
        this.removeSuccess(currentRow.uuid)
      }).finally(() => loading.close())
    },
    onCellChange(params) {
      const { node } = params
      if (node.data.uuid) {
        node.data.waitDealStatus = 'edit'
      }
    },
    saveSuccess(resp) {
      const params = resp.data
      if (!params) return
      // const row = this.rowData.find(row => params.uuid === row.uuid)
      // if (row) {
      //   Object.assign(row, params)
      // } else {
      //   this.rowData.push(params)
      // }
      // this.loadList(this.rowData)
      // 刷新
      this.refreshHandler()
      this.gridOptions.api.refreshCells({ force: true })
    },
    removeSuccess(uuid) {
      const index = this.rowData.findIndex(params => params.uuid === uuid)
      if (index > -1) {
        this.rowData.splice(index, 1)
        this.gridOptions.api.refreshCells({ force: true })
      }
      this.$message.success(this.$t('Message.DeleteSuccessfully'))
    },
    bizTypeDDLLabelFun(rule) {
      const state = CommonState.getStateByCode(FinanceInterfaceConstants.BIZ_DATA_TYPES, rule.businessDataType)
      let label = state == null ? '' : state.chineseName
      if (label && rule.accountingMode && rule.accountingMode === FinanceInterfaceConstants.MODE_HEDGE.code) {
        label += '(' + FinanceInterfaceConstants.MODE_HEDGE.label + ')'
      }
      return label
    },
    bizTypeChangeHandler(rule) {
      if (rule.accountingDocumentRuleUuid) {
        const docRule = this.accountingDocumentRules.find(params => params.uuid === rule.accountingDocumentRuleUuid)
        let key = docRule.businessDataType.toString()
        if (Number(docRule.accountingMode) === FinanceInterfaceConstants.MODE_HEDGE.code) {
          key += '#'
        }
        this.entryTypeDataProvider = Array.from(FinanceInterfaceConstants.MAPPING[key])
      } else {
        this.entryTypeDataProvider = []
      }
    },
    async rowDoubleClickHandler(params) {
      this.selectedItem = params.data
      const cell = this.gridOptions.api.getFocusedCell()
      const colId = cell.column.getColId()
      const entryAccountTitle = params.data
      if (colId === 'name') {
        // 双击科目名称,显示修改科目名称弹窗
        this.nameDialog.entryAccountTitle = entryAccountTitle
        this.nameDialog.visible = true
      } else if (colId.includes('level')) {
        // 双击1-6级科目,显示编辑科目弹窗
        const grade = Number(colId.substr('level'.length, 1))
        let subAccountItem
        for (const item of entryAccountTitle.subAccountItem) {
          if (item.grade === grade) {
            subAccountItem = item
            break
          }
        }
        const accountingEntryRuleList = await this.loadAccountingEntryRule('', this.accountSet.uuid, entryAccountTitle.entryType)
        const rule = this.getEntryRule(accountingEntryRuleList, entryAccountTitle.entryType, entryAccountTitle.businessDataType)
        if (rule === null) {
          const entryType = CommonState.getStateByCode(FinanceInterfaceConstants.ENTRY_TYPES, entryAccountTitle.entryType)
          this.$message.warning(this.$t('CargoMsg.Cargo_JEODTD').format(entryType.chineseName))
          return
        }
        if (rule.entrySeries >= grade && rule.entrySeries > 0) {
          if (!subAccountItem) {
            subAccountItem = {}
            subAccountItem.grade = grade
            subAccountItem.entryAccountTitleUuid = entryAccountTitle.uuid
          }
          this.entryAccountDialog.subAccountItem = subAccountItem
          this.entryAccountDialog.entryRule = rule
          this.entryAccountDialog.visible = true
        }
      }
    },
    async loadAccountingEntryRule(ruleUuid, accountSetUuid, entryType) {
      const params = {}
      params.accountingDocumentRuleUuid = ruleUuid
      params.accountSetUuid = accountSetUuid
      params.entryType = entryType
      return await accountingEntryRuleApi.query(params).then(resp => resp.data.list)
    },
    dialogCloseHandler(params) {
      this.entryAccountDialog.subAccountItem = null
      this.entryAccountDialog.entryRule = null
      if (params) {
        this.saveSuccess({ data: params })
      }
    },
    getEntryRule(accountingEntryRuleList, entryType, businessDataType) {
      let entryRule = null
      for (const rule of accountingEntryRuleList) {
        if (rule.entryType === entryType && rule.businessDataType === businessDataType) {
          entryRule = rule
          break
        }
      }
      if (entryRule === null) {
        for (const accountingEntryRule of accountingEntryRuleList) {
          if (accountingEntryRule.entryType === entryType) {
            entryRule = accountingEntryRule
            break
          }
        }
      }
      return entryRule
    }
  }
}
</script>

<style scoped>

</style>
